export const REPORTS = {
  productNewsPromotions: {
    id: 'product-news-promotions',
    title: 'Nové položky a položky v akci',
    downloadApiPath: '/api/reports/product-news-promotions/download',
  },
  duplicateEan: {
    id: 'duplicate-ean',
    title: 'Duplicitní EAN',
    downloadApiPath: '/api/reports/duplicate-ean/download',
  },
  minimumStock: {
    id: 'minimum-stock',
    title: 'Minimální množství skladem',
    downloadApiPath: '/api/reports/minimum-stock/download',
  },
} as const

export const REPORT_DEFINITIONS = Object.values(REPORTS)

export interface ReportDownload {
  id: string
  title: string
  downloadApiPath: string
}

export interface AvailableReport extends ReportDownload {
  lastFileName: string
  lastRun?: string
}
